'use strict';

var RulesReadonlyCriteriaListingDirective = function RulesReadonlyCriteriaListingDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/rules-readonly-criteria-listing.html'),
    scope: {
      parsedConditions: '=',
      showQuantifier: '='
    },
    link: function link($scope) {
      $scope.isCriteriaNotSpecified = function () {
        return !$scope.parsedConditions || $scope.parsedConditions.length === 1 && $scope.parsedConditions[0].isEmpty();
      };
    }
  };
};
RulesReadonlyCriteriaListingDirective.$inject = [];
module.exports = RulesReadonlyCriteriaListingDirective;